export const quizQuestions = [
  {
    question: '太阳系中最大的行星是哪一颗？',
    options: ['地球', '木星', '土星', '海王星'],
    correctAnswer: 1,
    explanation: '木星是太阳系中最大的行星，质量是其他所有行星总和的2.5倍。'
  },
  {
    question: '哪颗行星被称为"红色星球"？',
    options: ['金星', '火星', '水星', '木星'],
    correctAnswer: 1,
    explanation: '火星表面覆盖着氧化铁（铁锈），因此呈现红色。'
  },
  {
    question: '太阳系中最热的行星是？',
    options: ['水星', '金星', '地球', '火星'],
    correctAnswer: 1,
    explanation: '金星表面温度高达465°C，比水星还热，因为浓厚的二氧化碳大气层产生强烈的温室效应。'
  },
  {
    question: '土星环的主要成分是什么？',
    options: ['岩石', '冰块和岩石', '气体', '金属'],
    correctAnswer: 1,
    explanation: '土星环主要由冰块和岩石碎片组成。'
  },
  {
    question: '哪个行星的自转轴倾斜角接近98度，几乎是"躺着"公转？',
    options: ['天王星', '海王星', '土星', '木星'],
    correctAnswer: 0,
    explanation: '天王星的自转轴倾斜角度达98度，使其"躺着"公转。'
  },
  {
    question: '太阳占据了太阳系总质量的多少？',
    options: ['50%', '75%', '99.86%', '90%'],
    correctAnswer: 2,
    explanation: '太阳占据了太阳系总质量的99.86%。'
  },
  {
    question: '地球上有多少比例的表面被海洋覆盖？',
    options: ['50%', '60%', '71%', '80%'],
    correctAnswer: 2,
    explanation: '地球约71%的表面被海洋覆盖。'
  },
  {
    question: '哪颗行星自转方向与其他行星相反？',
    options: ['水星', '金星', '地球', '火星'],
    correctAnswer: 1,
    explanation: '金星是唯一反向自转的行星，所以太阳从西边升起。'
  },
  {
    question: '水星离太阳最近，它的公转周期是多少天？',
    options: ['88天', '165天', '225天', '687天'],
    correctAnswer: 0,
    explanation: '水星公转周期约为88个地球日，是太阳系中公转最快的行星。'
  },
  {
    question: '哪颗行星拥有最多的卫星？',
    options: ['木星', '土星', '天王星', '海王星'],
    correctAnswer: 1,
    explanation: '土星拥有已确认的82颗卫星，是太阳系中拥有卫星最多的行星。'
  },
  {
    question: '地球的卫星月球对地球有什么影响？',
    options: ['导致昼夜更替', '引起潮汐', '产生极光', '造成气候变化'],
    correctAnswer: 1,
    explanation: '月球的引力作用导致地球海洋产生潮汐现象，同时也稳定了地球的自转轴。'
  },
  {
    question: '哪颗行星被称为"冰巨星"？',
    options: ['木星', '土星', '天王星和海王星', '水星'],
    correctAnswer: 2,
    explanation: '天王星和海王星主要由水、甲烷和氨等冰物质组成，因此被称为冰巨星。'
  },
  {
    question: '太阳的光和热来自什么过程？',
    options: ['核聚变', '核裂变', '化学反应', '燃烧'],
    correctAnswer: 0,
    explanation: '太阳内部进行核聚变反应，将氢转化为氦，释放出巨大的能量。'
  },
  {
    question: '木星表面的"大红斑"是什么？',
    options: ['火山', '风暴', '撞击坑', '海洋'],
    correctAnswer: 1,
    explanation: '木星的大红斑是一个持续了几百年的巨大反气旋风暴。'
  },
  {
    question: '哪颗行星被称为"启明星"或"长庚星"？',
    options: ['水星', '金星', '火星', '木星'],
    correctAnswer: 1,
    explanation: '金星在天空中非常明亮，早晨出现在东方时称为"启明星"，傍晚出现在西方时称为"长庚星"。'
  },
  {
    question: '太阳系最小的行星是哪颗？',
    options: ['水星', '火星', '金星', '地球'],
    correctAnswer: 0,
    explanation: '水星是太阳系中最小的行星，直径仅为4879公里。'
  },
  {
    question: '冥王星为什么被降级为矮行星？',
    options: ['太小了', '没有清空轨道上的其他天体', '离太阳太远', '太冷了'],
    correctAnswer: 1,
    explanation: '2006年国际天文学联合会将冥王星降级，因为它没有清空其轨道上的其他天体。'
  },
  {
    question: '地球的自转周期约为多长时间？',
    options: ['12小时', '24小时', '48小时', '30天'],
    correctAnswer: 1,
    explanation: '地球自转一周约需23小时56分4秒，约为24小时。'
  },
  {
    question: '哪颗行星的卫星"泰坦"拥有浓厚的大气层？',
    options: ['木星', '土星', '天王星', '海王星'],
    correctAnswer: 1,
    explanation: '土星的卫星泰坦是太阳系中唯一拥有浓厚大气层的卫星，大气主要由氮气组成。'
  },
  {
    question: '太阳系位于银河系的什么位置？',
    options: ['中心', '边缘', '旋臂上', '外围'],
    correctAnswer: 2,
    explanation: '太阳系位于银河系的一条旋臂——猎户座旋臂上，距离银河系中心约2.6万光年。'
  }
];
